export const PREVIOUS_PERIOD_LABEL = 'Previous period'

// The legend a trend draws: its series, and the previous period when the
// comparison is on. Built here so every chart names the second line the way
// the tooltip does.
export function legendFor(label, compare) {
  return compare
    ? [{ label, series: '1' }, { label: PREVIOUS_PERIOD_LABEL, series: 'previous' }]
    : [{ label, series: '1' }]
}
